export class User {
    id: number;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    status:string;
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/_models/user.ts